import React, { Fragment } from 'react'
import Avatar from 'src/core/components/avatar'
import { Check, Coffee, X } from 'react-feather'
import { FormattedMessage } from 'react-intl'

export const SuccessToast = () => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color='success' icon={<Check size={12} />} />
				<h6 className='toast-title'>
					<FormattedMessage id='Success' />
				</h6>
			</div>
		</div>
	</Fragment>
)

export const ErrorToast = () => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color='danger' icon={<X size={12} />} />
				<h6 className='toast-title'>
					<FormattedMessage id='Error' />
				</h6>
			</div>
		</div>
	</Fragment>
)

export const LoginSuccessToast = ({ username }) => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color='success' icon={<Coffee size={12} />} />
				<h6 className='toast-title font-weight-bold'>Welcome, {username}</h6>
			</div>
		</div>
		<div className='toastify-body'>
			<span>You have successfully logged in as a user to BetsCycle bets Admin.</span>
		</div>
	</Fragment>
)

export const LoginErrorToast = ({ title, desc }) => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color='danger' icon={<X size={12} />} />
				<h6 className='text-danger ml-50 mb-0'>{title}</h6>
			</div>
		</div>
		<div className='toastify-body'>
			<span>{desc}</span>
		</div>
	</Fragment>
)

export const ApiErrorToast = ({ title }) => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color='danger' icon={<X size={12} />} />
				<h6 className='toast-title'>{title}</h6>
			</div>
		</div>
	</Fragment>
)
